import React from "react"

import Icon from "../Utils/Icon"
import * as styles from "./Styles/Support.module.scss"
import "../../styles/layouts"
import classNames from "classnames/bind"
const cn = classNames.bind(styles)

export const contactPhone = "03-6368-1013"
export const contactMail = "lamp-support@locoguide.co.jp"
export const businessWeekdays = "平日"
export const businessHours = "10:00~12:00 / 13:00~18:30"

const Support: React.FC = () => {
  return (
    <div className={styles.support}>
      <h3>サポート窓口</h3>
      <div className={styles.detail}>
        <p className={cn("content", "contact")}>
          <Icon
            className={styles.icon}
            type="feather"
            name="phone"
            attr={{ width: 14, height: 14 }}
          />
          <span>{contactPhone}</span>
          <br />
          <Icon
            className={styles.icon}
            type="feather"
            name="mail"
            attr={{ width: 14, height: 14 }}
          />
          <a href={`mailto:${contactMail}`}>{contactMail}</a>
        </p>
        <h4>受付時間</h4>
        <p className={cn("content", "businessHours")}>
          {businessWeekdays}
          <br />
          {businessHours}
        </p>
      </div>
    </div>
  )
}
export default Support
